import { Box, Skeleton, useToast } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetUserActiveCreditFacilitiesQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import { PortfolioStatementsExpensesFeesChart } from './PortfolioStatementsExpensesFeesChart';
import { errorToastConfig } from 'packages/common-frontend/constants';
import { useGetLedgerAccountsQuery } from 'packages/statements/requests/ledger.gql.generated';
import { ExpensesFeesTableContainer } from 'packages/statements/ui/ExpensesFeesViewContainer';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';

// Exports
type PortfolioStatementsExpensesFeesContainerProps = {
  creditFacilityId: string;
};
export const PortfolioStatementsExpensesFeesContainer = ({
  creditFacilityId,
}: PortfolioStatementsExpensesFeesContainerProps) => {
  const flags = useFeatureFlags();
  const toast = useToast();
  const navigate = useNavigate();

  const { data: userData } = useGetUserActiveCreditFacilitiesQuery({
    variables: {
      creditFacilitySlugsToHide: flags.creditFacilitySlugsToHide ?? [],
    },
  });
  const {
    data: ledgerAccountsData,
    loading: isLedgerAccountsLoading,
  } = useGetLedgerAccountsQuery({
    variables: {
      creditFacilityId,
      ledgerAccountGroup: 'expensesFees',
    },
  });

  if (
    !userData ||
    !userData.user ||
    !ledgerAccountsData ||
    isLedgerAccountsLoading
  ) {
    return (
      <Skeleton
        data-testid="loading-portfolio-statements-expenses-fees"
        height="600px"
      />
    );
  }

  const {
    user: { organizationId, organization: creditFacilities },
  } = userData;

  const creditFacilitySlug = _.find(
    creditFacilities.creditFacilities,
    ({ id }) => id === creditFacilityId,
  )?.slug;

  if (!creditFacilityId || !creditFacilitySlug) {
    navigate('/portfolio/overview/facilities');
    toast({
      ...errorToastConfig,
      id: 'errorLoadPortfolioStatementsExpensesFeesNoCreditFacility',
      title: 'Please select a credit facility.',
    });
    return null;
  }

  return (
    <Box>
      <PortfolioStatementsExpensesFeesChart
        accounts={ledgerAccountsData.ledgerAccounts}
        creditFacilityId={creditFacilityId}
        organizationIds={[organizationId]}
        chartTitle="Expenses & Fees"
      />
      <ExpensesFeesTableContainer
        accounts={ledgerAccountsData.ledgerAccounts}
        creditFacilityId={creditFacilityId}
        organizationIds={[organizationId]}
      />
    </Box>
  );
};
